import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import {
  Component,
  AfterViewInit,
  ViewChild,
  OnInit,
  OnChanges,
  SimpleChanges,
  ChangeDetectorRef,
  Input
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';

import * as L from 'leaflet';
import 'leaflet.markercluster'; // Importa il plugin
import {
  BehaviorSubject,
  combineLatest,
  debounceTime,
  EMPTY,
  filter,
  fromEvent,
  interval,
  Observable,
  Subject,
  Subscription,
  switchMap,
  take,
  takeUntil
} from 'rxjs';

import {
  selectIsLoading,
  selectIsRefreshing,
  selectIotAssetState,
  selectIotAssets,
  selectTotalAssets
  } from '../../../core/store/iotAssets/iotAsset.selector';
import * as IotAssetActions from '../../../core/store/iotAssets/iotAsset.actions';
import * as PostActions from '../../../core/store/actions';
import { MapContainerService } from 'src/app/core/services/mapContainer.service';

import { IotAssetState } from 'src/app/core/store/iotAssets/iotAsset.reducer';


import { getCompleteState, getCompleteStateAllAssets } from 'src/app/core/store/selectors';
import { SelectedCustomerCacheInterface } from 'src/app/core/store/interface/selectedCustomerCache.interface';
import { SelectedAssets } from 'src/app/core/store/interface/selectedAssets.interface';
import * as moment from 'moment';
import { select, Store } from '@ngrx/store';
import { AppStateInterface } from 'src/app/appState.interface';

import { fas } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { DataService } from 'src/app/core/services/data.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { environment } from 'src/environments/environment';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { UtilsService } from 'src/app/core/services/utils.service';
import {
  trigger,
  transition,
  style,
  animate,
  state
} from '@angular/animations';
import { set } from 'lodash';
// import { ShepherdService } from 'angular-shepherd';
// import { DEFAULT_STEP_OPTIONS } from 'src/app/pages/historical-journey/mock';
import { MatDialog } from '@angular/material/dialog';
import { HelpHeaderPopupComponent } from '../page-header/help-header-popup/help-header-popup.component';
import { IotAsset } from 'src/app/core/models/iotAssetsModel.data';
import { IotAssetsService } from 'src/app/core/services/iotAssets.service';
import { ActiaMapService } from 'src/app/core/services/actia-map.service';
import { ApiService } from 'src/app/core/services/api.service';
import { TRACKING_FIELDS_ENDPOINT } from 'src/app/core/config/config.constants';

@Component({
  selector: 'app-actia-map',
  templateUrl: './actia-map.component.html',
  styleUrls: ['./actia-map.component.scss'],
  providers: [ActiaMapService],
  animations: [
    trigger('flipAnimation', [
      state('visible', style({ transform: 'rotateY(0)', opacity: 1 })),
      state('hidden', style({ transform: 'rotateY(90deg)', opacity: 0 })),
      transition('visible <=> hidden', [
        animate('400ms cubic-bezier(0.4,0,0.2,1)')
      ])
    ])
  ]
})
export class ActiaMapComponent implements OnInit, OnChanges {
  map: L.Map | undefined;
  @Input() mapId: string = `actiaMap_${Math.floor(Math.random() * 10000)}`; // ID con fallback random se non fornito
  isMobile: boolean = false;
  vehicles$: Observable<IotAsset[]>;
  isLoading$: Observable<boolean>;
  isRefreshing$: Observable<boolean>;
  totalVehicles$: Observable<number> | undefined;
  totalVehiclesParked$: Observable<number> | undefined;
  totalVehiclesMoving$: Observable<number> | undefined;
  totalVehiclesIdle$: Observable<number> | undefined;
  totalVehiclesUnknown$: Observable<number> | undefined;
  totalVehiclesNotConnected$: Observable<number> | undefined;
  private destroy$ = new Subject<void>(); // Subject per gestire la distruzione
  activeFooterButton: string = 'map'; // Imposta il bottone attivo iniziale
  detailVehicleRow$ = new BehaviorSubject<IotAsset | null>(null);
  @ViewChild('sidenavMap') sidenav!: MatSidenav; // Riferimento al sidenav
  @ViewChild('sideBarMap') sideBarMapComponent!: any; // Riferimento al componente sidebar
  private refreshInterval: any; // Riferimento all'interval
  isTotalsCardVisible: boolean = false; // Variabile per tracciare la visibilità della card dei totali
  private totalsControlElement: HTMLElement | null = null; // Riferimento alla card dei totali
  // Aggiungi una proprietà per tracciare se la mappa è stata già centrata
  private mapCentered = true;
  // Proprietà per tracciare lo stato del caricamento
  private vehiclesLoaded = false;
  private fieldsLoaded = false;
  // All'interno della classe
  private resizeObserver: ResizeObserver | null = null;
  private tutorialSelectedVehicle: IotAsset | null = null; // Veicolo selezionato durante il tutorial
  addressValues: any[] = [null, null];
  mapTotals = {
    totalVehicles: 0,

    totalVehiclesParked: 0,
    totalVehiclesMoving: 0,
    totalVehiclesIdle: 0,
    totalVehiclesUnknown: 0,
    totalVehiclesNotConnected: 0
  };
  markerClusterGroup: L.MarkerClusterGroup | undefined;

  getCompleState: Subscription;
  selectedCustomerUidSelector$: SelectedCustomerCacheInterface;
  listApplySelectedAssets$: SelectedAssets;
  timingsStartPeriod: any;
  timingsEndPeriod: any;
  oldCustomer: SelectedCustomerCacheInterface;
  private previousSelectedAssetUids: string[] = [];
  showDetailsFromParent = false;

  private translations: { [key: string]: string } = {};
  private translationsLoaded$ = new BehaviorSubject<boolean>(false);
  isSearchRoute: Subscription;
  isTutorial: Subscription;
  searchList: boolean = false;

  inputs = [
    {
      value: 'input1',
      marker: null as any,
      coordinate: null as any,
      polygons: null as any,
      index: 0
    },
    {
      value: 'input2',
      marker: null as any,
      coordinate: null as any,
      polygons: null as any,
      index: 1
    }
  ];
  addressCoordinate: any = [];
  activeVehicleId: null;
  followVehicleInformation: null;
  http3: any;
  showDirections: boolean;
  routeBackgroundLine: any;
  routeBackgroundLinePath: any;
  durationSummary: number;
  durationLength: number;
  routerNavigation: any[];
  stringDurationSummary: string = '';
  stringDurationLength: string;
  vehicleType: string = 'truck';
  timeDistance: number = 0;
  distance: number = 50;
  time: string = '02:00';
  typeTimeDistance: string = 'distance';
  switchValues: boolean[] = [];
  modalMsgComponent: any;
  buttonInfo: boolean;
  suggestions: string[] = [];

  private subscriptions: Subscription[] = [];
  language: string;
  openSearchRoute = false;
  showSearchRouteForm = false;
  wasOpened = false;
  sectionRoute: any[] = [];
  showSectionRoute: boolean = false;
  temporalTypology: number = 1;
  type: any = [];

  // Aggiungi una proprietà per tracciare la section evidenziata
  openedAccordionIndex: number | null = null;
  highlightedSectionIndex: number | null = null;

  private _actionPointMarker: any = null;
  routeInputChanged: boolean = false;

  // Aggiungiamo le proprietà per i fields agricoli
  fields: any[] = [];
  fieldsList: any[] = [];
  isField: boolean = false;

  // Proprietà per evitare chiamate multiple a setFields
  private fieldsLoadingInProgress: boolean = false;
  private fieldsLoadTimeout: any = null;
  private lastFieldsCustomerUid: string | null = null;

  // Proprietà per il pannello geofence
  geofenceActive: boolean = false;       // Se i geofence sono attivi
  geofenceNavOpened: boolean = false;    // Se il pannello è aperto
  visibleGeofences: any[] = [];
  writeGeofenceGrant: boolean = true;
  listVehiclesInfo: any[] = [];
  geofenceDraw: any = null;
  selectedItems: any[] = [];
  editMode: boolean = false;

  @Input() toolbarButton: any[] = [
   false, true, true, false, false, false, true,false, 'actiaMap'
  ];
  @Input() showSidebar : boolean = true;
  @Input() showToolbar: boolean = true;
  @Input() containerMapHeight : string = '95vh';
  @Input() enableDrag : boolean = true;
  @Input() hideFields : boolean = false;
  // Chiave per il localStorage del tutorial

  private readonly TUTORIAL_SHOWN_KEY = 'actia_map_tutorial_shown';
  constructor(
    private storeMap: Store<{ iotAssets: IotAssetState }>,
    private store: Store<AppStateInterface>,
    private breakpointObserver: BreakpointObserver,
    private mapManager: ActiaMapService,
    private mapContainerService: MapContainerService,
    private translate: TranslateService,
    private dataService: DataService,
    private handler: HttpBackend,
    private utilsService: UtilsService,
    private cdr: ChangeDetectorRef,
   // private shepherdService: ShepherdService,
    private dialogService: MatDialog,
    private apiService: ApiService,
    private iotAssetsService: IotAssetsService,
  ) {
    //  console.log('ActiaMapComponent constructor');

    // Inizializza il servizio IotAssets solo quando il componente viene effettivamente utilizzato
  //  this.iotAssetsService.initializeService();

    this.vehicles$ = this.storeMap.select(selectIotAssets);
     this.isLoading$ = this.storeMap.select(selectIsLoading);
     this.isRefreshing$ = this.storeMap.select(selectIsRefreshing);
     this.totalVehicles$ = this.storeMap.select(selectTotalAssets);
    // this.totalIgnitionOff$ = this.store.select(selectTotalIgnitionOff);
    // this.totalIgnitionOn$ = this.store.select(selectTotalIgnitionOn);
    // this.totalVehiclesParked$ = this.storeMap.select(
    //   selectTotalVeichiclesParked
    // );
    // this.totalVehiclesMoving$ = this.storeMap.select(
    //   selectTotalVeichiclesMoving
    // );
    // this.totalVehiclesIdle$ = this.storeMap.select(selectTotalVeichiclesIdle);
    // this.totalVehiclesUnknown$ = this.storeMap.select(
    //   selectTotalVeichicleUnknown
    // );
    // this.totalVehiclesNotConnected$ = this.storeMap.select(
    //   selectTotalVeichicleNotConnected
    // );

    //  // QUI SI AGGIORNA L'ELENCO DEI VICOLI IN BASE ALLO STATE
    //  this.vehicles$
    //    .pipe(takeUntil(this.destroy$))
    //    .subscribe((vehicles) => {
    //   //   console.log('Veicoli ricevuti nel componente: Costrunctor', vehicles);

    //      // FZ DA AGGIUNGERE PER AGGIORNARE LE ICONA SULLA MAPPA
    //      this.mapManager.updateMarkers(vehicles, false);
    //    });

    this.storeMap
      .select(selectIotAssets)
      ?.pipe(takeUntil(this.destroy$))
      .subscribe((vehicles) => {
        const selectedVehicle = vehicles.find((vehicle) => vehicle.plate);
        this.detailVehicleRow$.next(selectedVehicle || null);
        console.log('ZAK veicle in actiamap list', vehicles);
        // Popola listVehiclesInfo per il componente geofence-panel
        this.listVehiclesInfo = vehicles;
      });

    //    this.storeMap.select(selectVehicles)
    //    ?.pipe(takeUntil(this.destroy$))
    //    .subscribe((vehicles) => {
    // //    console.log('selectedVehicles$', vehicles);
    //      const selectedVehicle = vehicles.find(
    //        (vehicle) => vehicle.plate
    //      );
    //      this.detailVehicleRow$.next(selectedVehicle || null);
    //    });
    //     //this.setVehicles();
    this.getCompleState = this.store
      .pipe(select(getCompleteStateAllAssets))
      .subscribe((res) => {
        this.selectedCustomerUidSelector$ = res.applyCustomer;
        this.listApplySelectedAssets$ = res.applySelectedAssets;
        this.timingsStartPeriod = res.applySelectedPeriod.fromDtPicker;
        this.timingsEndPeriod = res.applySelectedPeriod.toDtPicker;
           // @FZ aggiunto fitler-ref-23 Sincronizza setSelectedAssets con applySelectedAssets da getCompleteState
              if (res.applySelectedAssets ) {
                this.store.dispatch(PostActions.setSelectedAssets({
                  assetType: res.applySelectedAssets.assetType,
                  selected: res.applySelectedAssets.selected,
                  totSelected: res.applySelectedAssets.totSelected,
                  isApply: res.applySelectedAssets.isApply,
                  selectionMode: res.applySelectedAssets.selectionMode,
                  isCapped: res.applySelectedAssets.isCapped
                }));
              }

        if (!this.oldCustomer) {
          this.oldCustomer = res.applyCustomer;

          // Carica i dati iniziali solo se non è un cambio cliente e se i dati sono disponibili
          if (this.selectedCustomerUidSelector$ && this.listApplySelectedAssets$ &&
              this.selectedCustomerUidSelector$.uid && this.listApplySelectedAssets$.assetType) {
            const uidAssets = this.getSelectedAssetUids();

            if (uidAssets.length > 0) {
              this.previousSelectedAssetUids = [...uidAssets]; // Salva gli asset iniziali
              this.storeMap.dispatch(
                IotAssetActions.loadIotAssets({
                  assetType: this.listApplySelectedAssets$.assetType,
                  uidCustomer: this.selectedCustomerUidSelector$.uid,
                  uidAssets: uidAssets
                })
              );
            }

            // I campi agricoli verranno caricati in ngAfterViewInit dopo l'inizializzazione della mappa
          }
        } else if (this.oldCustomer?.uid !== res.applyCustomer?.uid) {
          console.log('🔄 CAMBIO CUSTOMER rilevato:', {
            oldCustomer: this.oldCustomer?.uid,
            newCustomer: res.applyCustomer?.uid
          });

          // 🔧 IMPORTANTE: Ricarica la configurazione mapping per il nuovo customer
          if (res.applyCustomer?.uid) {
            this.iotAssetsService.handleCustomerChange(res.applyCustomer.uid);
          }

          // Reimposta il flag per centrare la mappa sui nuovi veicoli
          this.mapCentered = true;
          // Resetta la mappa e rimuovi tutti i marker esistenti
          if (this.mapManager) {
            // Chiama updateMarkers con array vuoto per ripulire i marker esistenti
            this.mapManager.updateMarkers([], true);
          }

          // Carica i veicoli per il nuovo cliente
          const uidAssetsForNewCustomer = this.getSelectedAssetUids();
          if (uidAssetsForNewCustomer.length > 0) {
            this.previousSelectedAssetUids = [...uidAssetsForNewCustomer]; // Reset per il nuovo customer
            this.storeMap.dispatch(
              IotAssetActions.loadIotAssets({
                assetType: this.listApplySelectedAssets$.assetType,
                uidCustomer: this.selectedCustomerUidSelector$.uid,
                uidAssets: uidAssetsForNewCustomer
              })
            );
          }
          this.mapContainerService.setActivePage('actia-map');
          this.mapContainerService.setSelectedVehicle(null); // Resetta il veicolo selezionato
          this.showDetailsFromParent = false;
          this.oldCustomer = res.applyCustomer;

          // Reset dei flag di caricamento per il nuovo cliente
          this.resetFieldsStateForNewCustomer();

          // ✅ RIATTIVATO - Reset dei campi agricoli per il nuovo cliente
          this.fields = []; // Reset dei campi locali
          // I campi verranno caricati automaticamente da ngAfterViewInit o ngOnChanges
          console.log('🔄 Customer cambiato - i campi saranno ricaricati automaticamente');
        } else {
          // Verifica se gli asset sono effettivamente cambiati
          const currentUidAssets = this.getSelectedAssetUids();

          // Confronta i nuovi asset con quelli precedenti
          const assetsChanged = this.hasAssetsChanged(currentUidAssets);

          console.log('📊 Verifica cambio assets:', {
            previousLength: this.previousSelectedAssetUids.length,
            currentLength: currentUidAssets.length,
            assetsChanged: assetsChanged
          });

          // Ricarica solo se gli asset sono effettivamente cambiati
          if (assetsChanged && currentUidAssets.length > 0 &&
              this.selectedCustomerUidSelector$ && this.selectedCustomerUidSelector$.uid) {
            console.log('🔄 Assets cambiati, ricarico i dati');
            this.previousSelectedAssetUids = [...currentUidAssets];

            this.storeMap.dispatch(
              IotAssetActions.loadIotAssets({
                assetType: this.listApplySelectedAssets$.assetType,
                uidCustomer: this.selectedCustomerUidSelector$.uid,
                uidAssets: currentUidAssets
              })
            );
          } else if (!assetsChanged) {
            console.log('⏭️ Assets non cambiati, skip ricaricamento');
          }
        }
      });
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Reagisci al cambiamento di hideFields
    if (changes['hideFields'] && !changes['hideFields'].firstChange) {
      console.log('🔄 hideFields changed:', this.hideFields);
      if (this.hideFields) {
        // Usa il nuovo sistema persistente per nascondere i campi
        this.mapManager?.updateFields([], false);
        this.fieldsLoaded = true; // Considera i campi "caricati" anche se nascosti
      } else {
        // Solo se c'è un customer e la mappa è inizializzata
        if (this.selectedCustomerUidSelector$?.uid && this.map) {
          console.log('🌾 Caricamento campi da ngOnChanges per hideFields=false');
          this.setFields();
        }
      }
    }
  }

  ngOnInit(): void {
    // Sottoscrizioni per i totali
    this.translate.setDefaultLang(this.dataService.getLanguage());
    this.language = this.dataService.getLanguage();

    // Carica tutte le traduzioni necessarie in una volta sola
    this.translate
      .get([
        'mapPage.internalId',
        'mapPage.refreshing',
        'mapPage.loading',
        'mapPage.totalVehicles',
        'mapPage.moving',
        'mapPage.idle',
        'mapPage.parked',
        'mapPage.notConnected'
      ])
      .pipe(take(1))
      .subscribe((translations) => {
        // Salva le traduzioni in una proprietà per uso futuro
        this.translations = translations;
        // Notifica che le traduzioni sono pronte
        this.translationsLoaded$.next(true);
      });

    // Configurazione del breakpoint per mobile
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe((result) => {
        this.isMobile = result.matches;
      });

    this.setupTotalsSubscriptions();

    // Sottoscrizione per il toggle del pannello geofence
    this.mapManager.geofencePanelToggle
      .pipe(takeUntil(this.destroy$))
      .subscribe((isOpen: boolean) => {
        this.geofenceNavOpened = isOpen;
        console.log(`🗺️ Geofence panel ${isOpen ? 'aperto' : 'chiuso'}`);

        // Ridimensiona la mappa dopo che l'animazione CSS è completata
        setTimeout(() => {
          this.resizeMap();
          console.log(`🔄 Mappa ridimensionata per geofence panel ${isOpen ? 'aperto' : 'chiuso'}`);
        }, 350); // 350ms per permettere alla transizione CSS (300ms) di completarsi
      });

    // Sottoscrizione per sincronizzare i geofence dal servizio
    this.mapManager.changeGeofence
      .pipe(takeUntil(this.destroy$))
      .subscribe((loaded: boolean) => {
        if (loaded) {
          // Geofence caricati - attiva il componente
          this.geofenceActive = true;
          this.visibleGeofences = [...this.mapManager.visibleGeofences];
          console.log(`🔄 Geofence attivati e sincronizzati: ${this.visibleGeofences.length}`);
        } else {
          // Geofence disattivati - disattiva tutto
          this.geofenceActive = false;
          this.geofenceNavOpened = false;
          this.visibleGeofences = [];
          console.log('🧹 Geofence disattivati completamente');
        }
      });

    // NON inizializzare geofence automaticamente
    // I geofence verranno caricati solo al primo click sul toggle
    // this.initializeTestGeofences();

    // Ascolta quando la pagina actia-map diventa attiva
    this.mapContainerService.activePage$
      .pipe(takeUntil(this.destroy$))
      .subscribe((activePage) => {
        // console.log('🔄 Cambio pagina attiva:', activePage);
        // Con il nuovo sistema persistente, i campi rimangono sulla mappa
        // Non è necessario ricaricarli ad ogni cambio di pagina
        if (activePage === 'actia-map') {
          // console.log('📍 Pagina actia-map attiva - campi persistenti già presenti');

          // Trigger resize event per simulare il ridimensionamento manuale
          setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
          }, 50);

          // Fai il resize della mappa dopo l'attivazione della pagina
          setTimeout(() => {
            if (this.map) {
              // console.log('Eseguendo resize della mappa dopo attivazione pagina actia-map');
              this.map.invalidateSize();
            }
          }, 150);

          // Verifica se i campi sono presenti, altrimenti ricaricali
          if (!this.hideFields && this.selectedCustomerUidSelector$?.uid) {
            const currentFieldsCount = this.mapManager.getFieldsPolygonsCount ? this.mapManager.getFieldsPolygonsCount() : 0;

            // Debug dello stato attuale
            setTimeout(() => {
              this.debugFieldsState();
            }, 100);

            // ✅ RIATTIVATO - Caricamento campi
            if (currentFieldsCount === 0) {
              // console.log('🌾 Nessun campo presente, ricaricamento necessario');
              setTimeout(() => {
                this.setFields();
              }, 300); // Delay maggiore per assicurarsi che la mappa sia pronta
            } else {
              // console.log('🌾 Campi già presenti (' + currentFieldsCount + '), forzando refresh per visibilità');

              // Forza sempre il refresh dei campi per assicurarsi che siano visibili
              setTimeout(() => {
                if (this.fields && this.fields.length > 0) {
                  // console.log('🔄 Re-applicando ' + this.fields.length + ' campi alla mappa');
                  this.mapManager.updateFields(this.fields, false);

                  // Forza la visibilità del layer dei campi dopo un breve delay
                  setTimeout(() => {
                    this.forceFieldsLayerVisibility();
                  }, 100);
                } else {
                  // console.log('🔄 Array fields locale vuoto, ricaricamento da API');
                  this.setFields();
                }
              }, 200);
            }
          }
        }
      });

    this.isSearchRoute = this.mapManager.openSearchRoute.subscribe((open) => {
      // Se si sta chiedendo di aprire la finestra
      if (open) {
        // Controlla se la finestra è già aperta
        if (this.showSearchRouteForm && this.openSearchRoute) {
          return; // Esci senza fare nulla
        }

        // Altrimenti, apri la finestra
        this.showSearchRouteForm = true;
        this.openSearchRoute = false;
        this.wasOpened = false;
        setTimeout(() => {
          this.wasOpened = true;
          this.openSearchRoute = true;
        }, 10); // piccolo delay per permettere il rendering iniziale
      } else {
        // Chiudi la finestra solo se è effettivamente aperta
        if (this.showSearchRouteForm) {
          this.openSearchRoute = false;
          setTimeout(() => {
            this.showSearchRouteForm = false;
          }, 400);
        }
      }
    });

    this.isTutorial = this.mapManager.tutorialActive.subscribe((active) => {
      if (this.isMobile) {
        let msg = this.translate.instant('newMap.description');
        this.dialogService.open(HelpHeaderPopupComponent, {
          width: '600px',
          data: msg
        });
      } else {
        if (active) {
          this.startTutorialManually();
        }
      }
    });

    this.subscriptions.push(
      this.mapManager.selectedStartAddress$.subscribe(async (startPoint) => {
        //console.log('Punto di partenza selezionato:', startPoint);
        this.addressValues[0] = startPoint;
        if (!this.inputs[0]) {
          this.inputs[0] = {
            value: 'input1',
            marker: null,
            coordinate: null,
            polygons: null,
            index: 0
          }; // Inizializza se non esiste
        }
        // Aggiorna il valore dell'input
        this.inputs[0].value =
          startPoint && startPoint.label ? startPoint.label : '';

        // Se c'è una struttura coordinate, aggiornala
        if (!this.inputs[0].coordinate) {
          this.inputs[0].coordinate = {};
        }
        if (startPoint) {
          this.inputs[0].coordinate.positionLat = startPoint.lat;
          this.inputs[0].coordinate.positionLng = startPoint.lng;
        }
        this.cdr.detectChanges();
      })
    );

    // Sottoscrizione al punto di arrivo
    this.subscriptions.push(
      this.mapManager.selectedEndAddress$.subscribe(async (endPoint) => {
        //console.log('Punto di partenza selezionato:', startPoint);
        this.addressValues[1] = endPoint;
        if (!this.inputs[1]) {
          this.inputs[1] = {
            value: 'input1',
            marker: null,
            coordinate: null,
            polygons: null,
            index: 0
          }; // Inizializza se non esiste
        }

        // Aggiorna il valore dell'input
        this.inputs[1].value = endPoint && endPoint.label ? endPoint.label : '';

        // Se c'è una struttura coordinate, aggiornala
        if (!this.inputs[1].coordinate) {
          this.inputs[1].coordinate = {};
        }
        if (endPoint) {
          this.inputs[1].coordinate.positionLat = endPoint.lat;
          this.inputs[1].coordinate.positionLng = endPoint.lng;
        }

        this.cdr.detectChanges();
      })
    );
  }

  onAnimationEnd(event: AnimationEvent) {
    // Quando termina la slide-in, rendi il div visibile senza transizione
    if (event.animationName === 'slideInLeft') {
      this.wasOpened = true;
    }
  }

  ngAfterViewInit(): void {
    // Attendi che le traduzioni siano caricate prima di inizializzare la mappa
    this.translationsLoaded$
      .pipe(
        filter((loaded) => loaded), // Procedi solo quando è true
        take(1),
        switchMap(() => {
          // Inizializza sempre una nuova mappa ma con ID fisso
          console.log('🆕 Inizializzo mappa con ID fisso:', this.mapId);
          this.map = this.mapManager.initMap(this.mapId, {
            center: [41.9028, 12.4964],
            zoom: 6
          });

          // Verifica che la mappa sia stata creata correttamente
          if (!this.map) {
            console.error('❌ Impossibile creare la mappa');
            return EMPTY;
          }

          // Inizializza il gruppo di cluster
          this.markerClusterGroup = L.markerClusterGroup({
            maxClusterRadius: 50,
            disableClusteringAtZoom: 18
          });

          if (this.map && this.markerClusterGroup) {
            this.map.addLayer(this.markerClusterGroup);
          }

          // Inizializza il layer group per i campi agricoli
          this.mapManager.initFieldsLayerGroup();

          // this.map?.on('moveend', () => {
          //   if (this.mapManager.activateRepo) {
          //     this.mapManager.loadTrafficData2();
          //   }
          // });

          // Se vuoi anche ascoltare lo zoom:
          // this.map?.on('zoomend', () => {
          //   console.log('La mappa ha cambiato zoom (zoomend)');
          // });

          // Usa le traduzioni già caricate
          this.mapManager.addStatusControl(
            this.translations['mapPage.loading'] || 'Loading',
            this.translations['mapPage.refreshing'] || 'Refreshing'
          );

          // Aggiungi i controlli per la mappa
          this.mapManager.updateStatusIcons(
            this.isLoading$,
            this.isRefreshing$
          );
          if (this.showToolbar)
             this.mapManager.addToolbar(...this.toolbarButton);
          this.mapManager.initClusterGroup();
          this.mapSpecControl();

          // Ritorna l'observable dei veicoli
          return this.vehicles$;
        })
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe((vehicles) => {
        // 🔍 DEBUG: Mostra i veicoli ricevuti dal servizio IoT
        // console.log('🚜 DEBUG MAP COMPONENT - Veicoli ricevuti (GIÀ PROCESSATI):', vehicles.length);
        // console.log('🔍 DEBUG MAP COMPONENT - Struttura primo veicolo:', vehicles[0]);
        // console.log('✅ ARCHITETTURA: Processing centralizzato nel servizio - NO double processing!');

        // Verifica le coordinate dei primi 3 veicoli
        // vehicles.slice(0, 3).forEach((vehicle, index) => {
        //   console.log(`📍 DEBUG MAP COMPONENT - Veicolo ${index + 1} (${vehicle.plate || 'N/A'}):`, {
        //     lat_current: vehicle.lat_current,
        //     lon_current: vehicle.lon_current,
        //     hasValidCoordinates: !!(vehicle.lat_current && vehicle.lon_current)
        //   });
        // });

        // 🚀 NUOVO: I veicoli arrivano già processati con indirizzi dal servizio!
        // console.log('🏠 DEBUG MAP COMPONENT - Veicoli con indirizzi già processati:', vehicles.length);
        // vehicles.slice(0, 2).forEach((vehicle, index) => {
        //   console.log(`🏠 DEBUG MAP COMPONENT - Veicolo ${index + 1}:`, {
        //     plate: vehicle.plate || 'N/A',
        //     addressCurrent: vehicle.addressCurrent,
        //     lat_current: vehicle.lat_current,
        //     lon_current: vehicle.lon_current
        //   });
        // });

        // Aggiorna i marker con i dati completi (già con indirizzi)
        // NON centrare ancora - aspetta che anche i campi siano caricati
        this.mapManager.updateMarkers(vehicles, false);

        // Imposta flag veicoli caricati
        if (vehicles.length > 0) {
          this.vehiclesLoaded = true;
          // console.log('✅ Veicoli caricati, controllo centramento...');
          this.checkAndCenterMap();
        }

        // ✅ RIATTIVATO - Carica i campi agricoli dopo l'inizializzazione della mappa
        // Solo se hideFields è false E non sono già in fase di caricamento
        if (!this.hideFields && this.selectedCustomerUidSelector$?.uid && !this.fieldsLoadingInProgress) {
          console.log('📍 Caricamento iniziale campi agricoli da ngAfterViewInit...');
          // Sempre carica i campi all'inizializzazione con delay maggiore per evitare sovrapposizioni
          setTimeout(() => {
            // Verifica di nuovo che non sia già in corso
            if (!this.fieldsLoadingInProgress) {
              this.setFields();
            } else {
              console.log('⏭️ Caricamento già in corso, skip ngAfterViewInit');
            }
          }, 1000); // Delay ridotto ma con controllo aggiuntivo
        }

        // Imposta sempre la pagina attiva su actia-map quando questo componente viene inizializzato
        this.mapContainerService.setActivePage('actia-map');
      });

    // Carica i veicoli solo dopo l'inizializzazione della mappa e quando i dati dello store sono disponibili
    this.translationsLoaded$
      .pipe(
        filter((loaded) => loaded),
        take(1)
      )
      .subscribe(() => {
        // Configurazione resize e auto refresh
        this.setupResizeObserver();
      //  this.setupAutoRefresh();

        // Controlla se avviare il tutorial automaticamente
        if (!this.isMobile) {
          this.checkAndStartTutorial();
        }
      });

    this.translate.get('map.time').subscribe((time) => {
      this.type.push({ id: 0, text: time });
    });
    this.translate.get('map.distance').subscribe((distance) => {
      this.type.push({ id: 1, text: distance });
      this.temporalTypology = this.type[1].id;
      let t = {
        value: {
          id: this.type[1].id
        }
      };
    //  this.onRadioGroupChange(t);
    });
  }
  // Aggiungi questo metodo per centralizzare le sottoscrizioni dei totali
  private setupTotalsSubscriptions(): void {
    // Sottoscrizioni per i totali con un pattern più pulito
    const subscribeToTotal = (
      observable: Observable<number> | undefined,
      updateFn: (total: number) => void
    ) => {
      if (observable) {
        observable.pipe(takeUntil(this.destroy$)).subscribe(updateFn);
      }
    };

    subscribeToTotal(this.totalVehicles$, (total) => {
      this.mapTotals.totalVehicles = total;
      this.updateTotalsControl();
    });

    subscribeToTotal(this.totalVehiclesParked$, (total) => {
      this.mapTotals.totalVehiclesParked = total;
      this.updateTotalsControl();
    });

    subscribeToTotal(this.totalVehiclesMoving$, (total) => {
      this.mapTotals.totalVehiclesMoving = total;
      this.updateTotalsControl();
    });

    subscribeToTotal(this.totalVehiclesIdle$, (total) => {
      this.mapTotals.totalVehiclesIdle = total;
      this.updateTotalsControl();
    });

    subscribeToTotal(this.totalVehiclesUnknown$, (total) => {
      this.mapTotals.totalVehiclesUnknown = total;
      this.updateTotalsControl();
    });

    subscribeToTotal(this.totalVehiclesNotConnected$, (total) => {
      this.mapTotals.totalVehiclesNotConnected = total;
      this.updateTotalsControl();
    });
  }
  resizeMap(): void {
    if (this.map) {
      this.map.invalidateSize();
    }
  }
  showMap(): void {
    this.setActiveFooterButton('map'); // Imposta "map" come attivo
    this.sidenav.close(); // Chiude la sidebar

    // Trigger resize event per simulare il ridimensionamento manuale
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 50);

    // Fai il resize della mappa dopo la chiusura della sidebar
    setTimeout(() => {
      if (this.map) {
        console.log('Eseguendo resize della mappa dopo showMap');
        this.map.invalidateSize();
      }
    }, 300);
  }

  toggleSidebar(): void {
    this.setActiveFooterButton('sidebar'); // Imposta "sidebar" come attivo
    this.sidenav.toggle(); // Apre o chiude la sidebar

    // Trigger resize event per simulare il ridimensionamento manuale
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 50);

    // Se stiamo passando alla vista mappa (sidebar chiusa), fai il resize della mappa
    setTimeout(() => {
      if (!this.sidenav.opened && this.map) {
        console.log('Eseguendo resize della mappa dopo chiusura sidebar');
        this.map.invalidateSize();
      }
    }, 300);
  }
  setActiveFooterButton(button: string): void {
    this.activeFooterButton = button;
  }

  private updateTotalsControlRetryCount = 0;
  private updateTotalsControl(): void {
    try {
      let totalsControlElement = this.totalsControlElement;
      if (!totalsControlElement) {
        totalsControlElement = document.querySelector('.totals-card');
        if (totalsControlElement) {
          this.totalsControlElement = totalsControlElement;
          this.updateTotalsControlRetryCount = 0;
        } else {
          this.updateTotalsControlRetryCount++;
          if (this.updateTotalsControlRetryCount < 10) {
            setTimeout(() => this.updateTotalsControl(), 100);
          } else {
            console.error('Impossibile trovare .totals-card dopo 10 tentativi. Blocca retry.');
          }
          return;
        }
      }
      const lblTotalVehicle = this.translations['mapPage.totalVehicles'] || 'Total vehicles';
      const lblMoving = this.translations['mapPage.moving'] || 'Moving';
      const lblIdle = this.translations['mapPage.idle'] || 'Idle';
      const lblParked = this.translations['mapPage.parked'] || 'Parked';
      const lblNotConnected = this.translations['mapPage.notConnected'] || 'Not connected';
      if (totalsControlElement) {
        totalsControlElement.innerHTML = `
        <div class="flex justify-between gap-4 border-2 border-solid p-2 border-cyan-700">
          <div class="text-center p-1 font-bold  tracking-tight">${lblTotalVehicle}:</div>
          <div  class="flex align-center justify-center text-xl text-cyan-700 font-bold ">${this.mapTotals.totalVehicles}</div>
        </div>
       <div class="flex justify-between pr-2 pl-2">
           <div class="font-bold p-1  tracking-tight text-green-700 italic">${lblMoving}:</div>
            <div  class="font-bold text-lg  underline  decoration-green-700">${this.mapTotals.totalVehiclesMoving}</div>
        </div>
          <div class="flex justify-between pr-2 pl-2">
          <div class="font-bold p-1  tracking-tight text-orange-400 italic">${lblIdle}:</div>
          <div  class="font-bold text-lg underline  decoration-orange-700 ">${this.mapTotals.totalVehiclesIdle}</div>
        </div>
         <div class="flex justify-between pr-2 pl-2">
          <div class="font-bold p-1  tracking-tight text-gray-700 italic">${lblParked}:</div>
          <div  class="font-bold text-lg underline  decoration-gray-700 ">${this.mapTotals.totalVehiclesParked}</div>
        </div>
         <div class="flex justify-between pr-2 pl-2">
          <div class="font-bold p-1  tracking-tight text-red-700 italic">${lblNotConnected}:</div>
          <div  class="font-bold text-lg underline  decoration-gray-700 ">${this.mapTotals.totalVehiclesNotConnected}</div>
        </div>
       `;
      }
    } catch (err) {
      console.error('[ERROR] updateTotalsControl exception:', err);
    }
  }

  private updateTotalsCardVisibility(): void {
    if (this.totalsControlElement) {
      if (this.isTotalsCardVisible) {
        this.totalsControlElement.classList.remove('custom-hidden');
        this.totalsControlElement.style.display = 'block';
      } else {
        this.totalsControlElement.classList.add('custom-hidden');
        this.totalsControlElement.style.display = 'none';
      }
    }
  }

  private updateToolbarIcon(div: HTMLElement): void {
    div.innerHTML = `
      <i class="fas ${this.isTotalsCardVisible ? 'fa-times' : 'fa-list-check'
      } text-gray-800 text-xl"></i>
    `;
  }

  centerMapOnMarkers(): void {
    //  this.map = this.mapManager.initMap(this.mapId,  { center: [45.0703, 7.6869], zoom: 13 });
    if (!this.map || !this.markerClusterGroup) {
      return;
    }

    const bounds = this.markerClusterGroup.getBounds(); // Ottieni i limiti dei marker
    if (bounds.isValid()) {
      this.map.fitBounds(bounds, {
        padding: [10, 10], // Padding in pixel attorno ai marker
        maxZoom: 18, // Zoom massimo per evitare zoom troppo ravvicinato
        animate: true // Animazione della transizione
      });
    } else {
      // Se non ci sono marker, centra su una posizione predefinita
      this.map.setView([41.9028, 12.4964], 5); // Centra su Roma
    }
  }

  // Aggiungi un metodo per configurare il refresh automatico
  private setupAutoRefresh(): void {
    // Pulisci eventuali intervalli esistenti
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }

    // Crea un nuovo intervallo con controllo degli stati
    this.refreshInterval = setInterval(() => {
      // Controlla gli stati prima di effettuare la richiesta
      let isCurrentlyLoading = false;
      let isCurrentlyRefreshing = false;

      // Ottieni i valori correnti degli stati
      const loadingSub = this.isLoading$.subscribe((loading) => {
        isCurrentlyLoading = loading;
      });

      // const refreshingSub = this.isRefreshing$.subscribe((refreshing) => {
      //   isCurrentlyRefreshing = refreshing;
      // });

      // Pulisci le sottoscrizioni temporanee
      loadingSub.unsubscribe();
      //refreshingSub.unsubscribe();

      // Effettua il refresh solo se non ci sono operazioni in corso
      if (!isCurrentlyLoading) {
        // console.log(
        //   'Auto refresh triggered - no loading or refreshing in progress'
        // )
        // console.log(this.listApplySelectedAssets$.selected);
        this.store.dispatch(
          IotAssetActions.refreshIotAssets({
            assetType: this.listApplySelectedAssets$.assetType,
            uidCustomer: this.selectedCustomerUidSelector$.uid,
            uidAssets: this.getSelectedAssetUids()
          })
        );
      } else {
        console.log('Skipping auto refresh - operation already in progress');
      }
    }, 10000); // 10 secondi
  }

  ngOnDestroy(): void {
    // Pulisci l'intervallo quando il componente viene distrutto
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
      this.refreshInterval = null;
    }

    // Pulisci il timeout per i fields e resetta i flag
    if (this.fieldsLoadTimeout) {
      clearTimeout(this.fieldsLoadTimeout);
      this.fieldsLoadTimeout = null;
    }

    // Reset dei flag di caricamento fields
    this.fieldsLoadingInProgress = false;
    this.lastFieldsCustomerUid = null;

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    // Pulisci la subscription per lo stato completo
    if (this.getCompleState) {
      this.getCompleState.unsubscribe();
    }

    // Pulisci tutte le subscription nell'array
    this.subscriptions.forEach(sub => {
      if (sub && !sub.closed) {
        sub.unsubscribe();
      }
    });
    this.subscriptions = [];

    // Pulisci le subscription specifiche
    if (this.isSearchRoute && !this.isSearchRoute.closed) {
      this.isSearchRoute.unsubscribe();
    }

    if (this.isTutorial && !this.isTutorial.closed) {
      this.isTutorial.unsubscribe();
    }

    // Completa il subject per terminare tutte le sottoscrizioni con takeUntil
    this.destroy$.next();
    this.destroy$.complete();

    console.log('🧹 Cleanup completo del componente actia-map');
  }

  mapSpecControl(): void {
    // Aggiungi un controllo per la toolbar
    const toolbarControl = new L.Control({ position: 'topright' });

    toolbarControl.onAdd = () => {
      const div = L.DomUtil.create(
        'div',
        'toolbar-control bg-white shadow-lg mr-0 p-1 cursor-pointer flex items-center justify-center w-8 h-8 detailCard'
      ); // Aumenta le dimensioni
      div.innerHTML = `
  <i class="fas ${this.isTotalsCardVisible ? 'fa-times' : 'fa-list-check'
        } text-gray-800 text-xl"></i> <!-- Icona dinamica -->
`;
      div.onclick = () => {
        this.isTotalsCardVisible = !this.isTotalsCardVisible;
        this.updateTotalsCardVisibility();
        this.updateToolbarIcon(div); // Aggiorna l'icona
      };
      return div;
    };

    if (this.map) {
      toolbarControl.addTo(this.map);

      // Aggiungi il controllo personalizzato per la card dei totali
      const totalsControl = new L.Control({ position: 'topright' });

      totalsControl.onAdd = () => {
        const div = L.DomUtil.create(
          'div',
          'totals-card bg-white shadow-lg rounded-lg p-2 text-sm text-gray-800 custom-hidden'
        );

        return div;
      };

      totalsControl.addTo(this.map);

      // Salva il riferimento alla card dei totali
      setTimeout(() => {
        this.totalsControlElement = document.querySelector('.totals-card');
        if (this.totalsControlElement) {
          // Inizializza immediatamente con i dati correnti
          this.updateTotalsControl();
          // Imposta la visibilità iniziale
          this.updateTotalsCardVisibility();
        } else {
          console.warn(
            "Elemento .totals-card non trovato dopo l'aggiunta alla mappa"
          );
        }
      }, 50);

      const centerMapControl = new L.Control({ position: 'topright' });

      centerMapControl.onAdd = () => {
        const div = L.DomUtil.create(
          'div',
          'center-map-control bg-white shadow-lg  p-1 cursor-pointer flex items-center justify-center w-8 h-8 '
        ); // Aumenta le dimensioni
        div.innerHTML = `
    <i class="fas fa-crosshairs text-gray-800 text-lg"></i> <!-- Icona del pulsante -->
  `;
        div.onclick = () => {
          this.centerMapOnMarkers(); // Chiama il metodo per centrare la mappa
        };
        return div;
      };

      centerMapControl.addTo(this.map);
    }
  }

  // Crea un array di uid dagli asset selezionati
  getSelectedAssetUids(): string[] {
    // Controlla se selected esiste ed è un array
    if (!this.listApplySelectedAssets$ || !this.listApplySelectedAssets$.selected) {
      return [];
    }

    // Se selected è un array, mappa gli uid
    if (Array.isArray(this.listApplySelectedAssets$.selected)) {
      let listAsset: string[] = [];
      for (let item of this.listApplySelectedAssets$.selected) {
        if (item && item.uid) {
          listAsset.push(item.uid);
        }
      }
      return listAsset;
    }

    // Se selected è un oggetto singolo con uid
    if (typeof this.listApplySelectedAssets$.selected === 'object' &&
        this.listApplySelectedAssets$.selected !== null &&
        !Array.isArray(this.listApplySelectedAssets$.selected) &&
        (this.listApplySelectedAssets$.selected as any).uid) {
      return [(this.listApplySelectedAssets$.selected as any).uid];
    }

    return [];
  }

  /**
   * Verifica se gli asset selezionati sono cambiati rispetto all'array precedente
   */
  private hasAssetsChanged(currentAssets: string[]): boolean {
    // Se le lunghezze sono diverse, sicuramente sono cambiati
    if (currentAssets.length !== this.previousSelectedAssetUids.length) {
      return true;
    }

    // Se sono entrambi vuoti, non sono cambiati
    if (currentAssets.length === 0 && this.previousSelectedAssetUids.length === 0) {
      return false;
    }

    // Ordina entrambi gli array per confrontarli
    const sortedCurrent = [...currentAssets].sort();
    const sortedPrevious = [...this.previousSelectedAssetUids].sort();

    // Confronta elemento per elemento
    for (let i = 0; i < sortedCurrent.length; i++) {
      if (sortedCurrent[i] !== sortedPrevious[i]) {
        return true;
      }
    }

    // Nessun cambiamento rilevato
    return false;
  }

  private setupResizeObserver(): void {
    if ('ResizeObserver' in window && this.map) {
      const mapContainer = this.map.getContainer();

      this.resizeObserver = new ResizeObserver(() => {
        if (this.map) {
          this.map.invalidateSize();
        }
      });

      this.resizeObserver.observe(mapContainer);
    }
  }

  drop(event: any) {
    moveItemInArray(this.inputs, event.previousIndex, event.currentIndex);
    moveItemInArray(
      this.addressCoordinate,
      event.previousIndex,
      event.currentIndex
    );

    // Aggiorna le label dei marker dopo il riordino
    this.inputs.forEach((input, idx) => {
      if (input.marker) {
        let iconLabel = '';
        if (idx === 0) {
          iconLabel = 'P';
        } else if (idx === this.inputs.length - 1) {
          iconLabel = 'A';
        } else {
          iconLabel = idx.toString();
        }
        const svgIcon = `
          <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
            <circle cx="20" cy="20" r="18" fill="#1976d2" stroke="#fff" stroke-width="3"/>
            <text x="50%" y="54%" text-anchor="middle" fill="#fff" font-size="20" font-family="Arial" dy=".3em">${iconLabel}</text>
          </svg>
        `;
        const icon = L.divIcon({
          html: svgIcon,
          className: '',
          iconSize: [40, 40],
          iconAnchor: [20, 40]
        });
        input.marker.setIcon(icon);
      }
    });
    this.routeInputChanged = true;

    //this.riordinaCoordinate();
  }

  anySwitchValueTrue(): boolean {
    return (
      Array.isArray(this.switchValues) && this.switchValues.some((v) => !!v)
    );
  }

  riordinaCoordinate() {
    this.addressCoordinate.forEach((item, index) => {
      item.index = index;
      if (!this.inputs[index].polygons) {
        this.switchValues[index] = false;
      }
    });

    this.addressCoordinate.sort((a, b) => a.index - b.index);

  }


  // Metodo per evidenziare una sola section
  highlightSection(idx: number) {
    if (!this.routeBackgroundLine) return;
    this.highlightedSectionIndex = idx;
    this.routeBackgroundLine.forEach((polyline, i) => {
      if (i === idx) {
        polyline.setStyle({
          color: '#3ea463',
          weight: 10,
          opacity: 1,
          zIndex: 9999
        });
        this.map?.fitBounds(polyline.getBounds(), {
          padding: [60, 60],
          maxZoom: 15,
          animate: true
        });
      } else {
        polyline.setStyle({
          color: '#5b9bf7',
          weight: 6,
          opacity: 1,
          zIndex: 1
        });
      }
    });
  }

  // AGGIUNGI QUESTO METODO per togliere evidenziazione dalle section
  clearSectionHighlight() {
    if (!this.routeBackgroundLine) return;
    this.highlightedSectionIndex = null;
    this.routeBackgroundLine.forEach((polyline) => {
      polyline.setStyle({ color: '#5b9bf7', weight: 6, opacity: 1, zIndex: 1 });
    });
  }

  convertKm(e) {
    let km =
      this.utilsService.convertFromKm(e / 1000) +
      ' ' +
      this.utilsService.getDistanceLabel();
    return km;
  }

  convertTime(e) {
    let time = e;
    let msg = '';
    let hours = Math.floor(time / 3600);
    time %= 3600;
    let minutes = Math.floor(time / 60);
    let seconds = time % 60;

    if (hours > 0) {
      if (hours > 1) {
        msg += `${hours} ${this.translate.instant('global.hours')} `;
      } else {
        msg += `${hours} ${this.translate.instant('global.hour')} `;
      }
      msg += `${minutes} ${this.translate.instant('global.minutes')}`;
    } else {
      msg += `${minutes} ${this.translate.instant(
        'global.minutes'
      )} ${seconds} ${this.translate.instant('global.seconds')}`;
    }
    return msg;
  }

  routeAddress(e) {
    let msg = e[0].nextRoad.name[0].value;

    msg += ' - ' + e[e.length - 1].currentRoad.name[0].value;

    return msg;
  }

  deleteSearchRoute() {
    if (this.routeBackgroundLine) {
      this.routeBackgroundLine.forEach((r) => this.map?.removeLayer(r));
    }
    if (this.routeBackgroundLinePath) {
      this.routeBackgroundLinePath.forEach((r) => this.map?.removeLayer(r));
    }
    this.routeBackgroundLine = [];
    this.routeBackgroundLinePath = [];
    // Rimuovi i marker e poligoni degli input
    this.inputs.forEach((input) => {
      if (input.marker) {
        this.map?.removeLayer(input.marker);
        input.marker = null;
      }
      if (input.polygons) {
        input.polygons.forEach((p: any) => this.map?.removeLayer(p));
        input.polygons = null;
      }
      input.coordinate = null;
    });
    // Pulisci anche addressCoordinate e switchValues
    this.addressCoordinate = [];
    this.switchValues = [];
    this.showSectionRoute = false;
    this.inputs = [
      {
        value: 'input1',
        marker: null as any,
        coordinate: null as any,
        polygons: null as any,
        index: 0
      },
      {
        value: 'input2',
        marker: null as any,
        coordinate: null as any,
        polygons: null as any,
        index: 1
      }
    ];
    // this.addressValues=[];
    this.mapManager.deleteRoutePoints();
  }

  onAccordionOpened(idx: number) {
    // Chiudi l'eventuale accordion già aperto e togli evidenziazione
    if (
      this.openedAccordionIndex !== null &&
      this.openedAccordionIndex !== idx
    ) {
      this.clearSectionHighlight();
    }
    this.openedAccordionIndex = idx;
    this.highlightSection(idx);
  }

  onAccordionClosed(idx: number, fitAll: boolean = false) {
    // Deseleziona solo se chiudi quello attualmente aperto
    if (this.openedAccordionIndex === idx) {
      this.openedAccordionIndex = null;
      this.clearSectionHighlight();
      if (fitAll) {
        this.fitAllRouteSections();
      }
    }
  }

  // Aggiungi questo metodo
  fitAllRouteSections() {
    if (
      this.routeBackgroundLine &&
      this.routeBackgroundLine.length > 0 &&
      this.map
    ) {
      let bounds = this.routeBackgroundLine[0].getBounds();
      for (let i = 1; i < this.routeBackgroundLine.length; i++) {
        bounds = bounds.extend(this.routeBackgroundLine[i].getBounds());
      }
      this.map.fitBounds(bounds, {
        padding: [60, 60],
        maxZoom: 15,
        animate: true
      });
    }
  }

  removeActionPointFromMap() {
    if (this._actionPointMarker) {
      this.map?.removeLayer(this._actionPointMarker);
      this._actionPointMarker = null;
    }
  }

  // Metodo per resettare lo stato del tutorial
  resetTutorialState(refresh: boolean = true) {

    if (this.sideBarMapComponent) {
      // Rimuovi eventuali selezioni di veicoli
      if (this.sideBarMapComponent.selectedVehicle) {
        this.sideBarMapComponent.selectedVehicle = null;
      }
      // Chiudi eventuali pannelli aperti
      if (this.sideBarMapComponent.closeVehiclePanel) {
        this.sideBarMapComponent.closeVehiclePanel();
      }
      // Reset del filtro se presente
      if (this.sideBarMapComponent.resetFilters) {
        this.sideBarMapComponent.resetFilters();
      }
      if (this.tutorialSelectedVehicle != null) {
        if (this.sideBarMapComponent.centerMapOnVehicle) {
          this.vehicles$.pipe(take(1)).subscribe(vehicles => {
            if (vehicles && vehicles.length > 0) {
              const firstVehicle = vehicles[0];
              if (this.sideBarMapComponent && this.sideBarMapComponent.centerMapOnVehicle) {
                this.sideBarMapComponent.centerMapOnVehicle(firstVehicle);
                this.cdr.detectChanges();
              }
            }
          });
        }
      }

      this.tutorialSelectedVehicle = null;
      this.centerMapOnMarkers();
      if (this.sidenav && this.sidenav.opened) {
        this.sidenav.close();
      }
    }

    // Forza il change detection per aggiornare l'UI
    this.cdr.detectChanges();
    if (!refresh) {
      this.setupAutoRefresh();
    }
  }

  // Metodi per gestire il localStorage del tutorial
  private isTutorialAlreadyShown(): boolean {
    return localStorage.getItem(this.TUTORIAL_SHOWN_KEY) === 'true';
  }

  private markTutorialAsShown(): void {
    localStorage.setItem(this.TUTORIAL_SHOWN_KEY, 'true');
  }

  // Metodo pubblico per resettare il flag del tutorial (utile per testing)
  resetTutorialFlag(): void {
    localStorage.removeItem(this.TUTORIAL_SHOWN_KEY);
  }

  // Metodo pubblico per avviare il tutorial manualmente
  startTutorialManually(): void {
    this.tutorialMap(true);
  }

  // Metodo per controllare se avviare il tutorial automaticamente
  checkAndStartTutorial(): void {
    if (!this.isTutorialAlreadyShown()) {
      // Aggiungi un piccolo delay per assicurarsi che tutto sia caricato
      setTimeout(() => {
        this.tutorialMap(false);
      }, 1000);
    }
  }

  tutorialMap(isManual: boolean = false) {
    let that = this;
    clearInterval(this.refreshInterval);

    // Se non è manuale, marca il tutorial come mostrato
    if (!isManual) {
      this.markTutorialAsShown();
    }

    // this.shepherdService.defaultStepOptions = DEFAULT_STEP_OPTIONS;
    // this.shepherdService.modal = true;
    // this.shepherdService.confirmCancel = false;
    const builtInButtons = {
      cancel: {
        classes: 'cancel-button',
        secondary: true,
        text: this.translate.instant('global.close'),
        action: function () {
          that.resetTutorialState(false);
          // that.shepherdService.cancel();
        },
      },
      next: {
        classes: 'next-button',
        text: this.translate.instant('global.next'),
        type: 'next'
      }
    };

    // Metodo helper per cliccare sul primo veicolo (centerMapOnVehicle)
    const clickFirstVehicle = () => {
      this.vehicles$.pipe(take(1)).subscribe(vehicles => {
        if (vehicles && vehicles.length > 0) {
          const firstVehicle = vehicles[0];
          this.tutorialSelectedVehicle = firstVehicle;
          if (this.sideBarMapComponent && this.sideBarMapComponent.centerMapOnVehicle) {
            this.sideBarMapComponent.centerMapOnVehicle(firstVehicle);
            // Forza il change detection dopo il click
            this.cdr.detectChanges();
          }
        }
      });
    };

    // Metodo helper per aprire il pannello del primo veicolo
    const openFirstVehiclePanel = () => {
      this.vehicles$.pipe(take(1)).subscribe(vehicles => {
        if (vehicles && vehicles.length > 0) {
          const firstVehicle = vehicles[0];
          if (this.sideBarMapComponent && this.sideBarMapComponent.openVehiclePanel) {
            this.sideBarMapComponent.openVehiclePanel(firstVehicle);
          }
        }
      });
    };

    // this.shepherdService.addSteps([
    //   {
    //     attachTo: {
    //       element: '.sidenav-container',
    //       on: 'bottom'
    //     },
    //     cancelIcon: {
    //       enabled: false
    //     },
    //     buttons: [
    //       builtInButtons.cancel,
    //       builtInButtons.next
    //     ],
    //     classes: 'shepherd-welcome',
    //     id: '.sidenav-container',
    //     title: this.translate.instant('global.tutorialNewMap.step1.title1'),
    //     text: this.translate.instant('global.tutorialNewMap.step1.text1')
    //   },
    //   {
    //     attachTo: {
    //       element: '.map-container',
    //       on: 'bottom'
    //     },
    //     cancelIcon: {
    //       enabled: false
    //     },
    //     buttons: [
    //       builtInButtons.cancel,
    //       builtInButtons.next
    //     ],
    //     classes: 'shepherd-info',
    //     id: '.map-container',
    //     title: this.translate.instant('global.tutorialNewMap.mapContainer.title1'),
    //     text: this.translate.instant('global.tutorialNewMap.mapContainer.text1')
    //   },
    //   {
    //     attachTo: {
    //       element: '.tootleButton',
    //       on: 'bottom'
    //     },
    //     cancelIcon: {
    //       enabled: false
    //     },
    //     buttons: [
    //       builtInButtons.cancel,
    //       builtInButtons.next
    //     ],
    //     when: {
    //       hide: async () => {
    //         if (!that.sidenav.opened) {
    //           await that.sidenav.open();
    //         }
    //       }
    //     },

    //     id: 'tootleButton',
    //     title: this.translate.instant('global.tutorialNewMap.tootleButton.title1'),
    //     text: this.translate.instant('global.tutorialNewMap.tootleButton.text1'),
    //   },
    //   {
    //     attachTo: {
    //       element: '.selectorFilter',
    //       on: 'bottom'
    //     },
    //     cancelIcon: {
    //       enabled: false
    //     },
    //     buttons: [
    //       builtInButtons.cancel,
    //       builtInButtons.next
    //     ],
    //     when: {
    //       hide: async () => {
    //         clickFirstVehicle();
    //       }
    //     },
    //     classes: 'shepherd-success',
    //     id: '.selectorFilter',
    //     title: this.translate.instant('global.tutorialNewMap.selectotFilter.title1'),
    //     text: this.translate.instant('global.tutorialNewMap.selectotFilter.text1')
    //   },
    //   {
    //     attachTo: {
    //       element: '.border-yellow-200',
    //       on: 'bottom'
    //     },
    //     cancelIcon: {
    //       enabled: false
    //     },
    //     buttons: [
    //       builtInButtons.cancel,
    //       builtInButtons.next
    //     ],
    //     when: {
    //       show: async () => {
    //         await new Promise(resolve => {
    //           let attempts = 0;
    //           const maxAttempts = 50;
    //           const checkElement = () => {
    //             const element = document.querySelector('.border-yellow-200');
    //             attempts++;

    //             if (element) {
    //               console.log('Elemento .border-yellow-200 trovato dopo', attempts * 100, 'ms');
    //               resolve(true);
    //             } else if (attempts >= maxAttempts) {
    //               console.warn('Timeout: elemento .border-yellow-200 non trovato dopo 5 secondi');
    //               resolve(false);
    //             } else {
    //               setTimeout(checkElement, 100);
    //             }
    //           };
    //           checkElement();
    //         });
    //       },
    //       hide: async () => {
    //         openFirstVehiclePanel();
    //       }
    //     },
    //     classes: 'shepherd-success',
    //     id: '.border-yellow-200',
    //     title: this.translate.instant('global.tutorialNewMap.border-yellow-200.title1'),
    //     text: this.translate.instant('global.tutorialNewMap.border-yellow-200.text1')
    //   },
    //   {
    //     attachTo: {
    //       element: '.info',
    //       on: 'bottom'
    //     },
    //     cancelIcon: {
    //       enabled: false
    //     },
    //     buttons: [
    //       builtInButtons.cancel,
    //       builtInButtons.next
    //     ],
    //     when: {
    //       show: async () => {
    //         await new Promise(resolve => setTimeout(resolve, 1000));
    //       }
    //     },
    //     classes: 'shepherd-success',
    //     id: '.info',
    //     title: this.translate.instant('global.tutorialNewMap.info.title1'),
    //     text: this.translate.instant('global.tutorialNewMap.info.text1')
    //   },
    //   {
    //     attachTo: {
    //       element: '.airline',
    //       on: 'bottom'
    //     },
    //     cancelIcon: {
    //       enabled: false
    //     },
    //     buttons: [
    //       builtInButtons.cancel,
    //       builtInButtons.next
    //     ],
    //     classes: 'shepherd-success',
    //     id: '.airline',
    //     title: this.translate.instant('global.tutorialNewMap.airline.title1'),
    //     text: this.translate.instant('global.tutorialNewMap.airline.text1')
    //   },
    //   {
    //     attachTo: {
    //       element: '.map_journey',
    //       on: 'bottom'
    //     },
    //     cancelIcon: {
    //       enabled: false
    //     },
    //     buttons: [
    //       builtInButtons.cancel,
    //       builtInButtons.next
    //     ],
    //     classes: 'shepherd-success',
    //     id: '.map_journey',
    //     title: this.translate.instant('global.tutorialNewMap.map_journey.title1'),
    //     text: this.translate.instant('global.tutorialNewMap.map_journey.text1')
    //   },
    //   {
    //     attachTo: {
    //       element: '.reports',
    //       on: 'bottom'
    //     },
    //     cancelIcon: {
    //       enabled: false
    //     },
    //     buttons: [
    //       builtInButtons.cancel,
    //       builtInButtons.next
    //     ],
    //     classes: 'shepherd-info',
    //     id: '.reports',
    //     title: this.translate.instant('global.tutorialNewMap.reports.title1'),
    //     text: this.translate.instant('global.tutorialNewMap.reports.text1')
    //   },
    //   {
    //     attachTo: {
    //       element: '.routeCalculation',
    //       on: 'bottom'
    //     },
    //     cancelIcon: {
    //       enabled: false
    //     },
    //     buttons: [
    //       builtInButtons.cancel,
    //       builtInButtons.next
    //     ],
    //     classes: 'shepherd-success',
    //     id: '.routeCalculation',
    //     title: this.translate.instant('global.tutorialNewMap.routeCalculation.title1'),
    //     text: this.translate.instant('global.tutorialNewMap.routeCalculation.text1')
    //   },
    //   {
    //     attachTo: {
    //       element: '.prohibitions',
    //       on: 'bottom'
    //     },
    //     cancelIcon: {
    //       enabled: false
    //     },
    //     buttons: [
    //       builtInButtons.cancel,
    //       builtInButtons.next
    //     ],
    //     classes: 'shepherd-success',
    //     id: '.prohibitions',
    //     title: this.translate.instant('global.tutorialNewMap.prohibitions.title1'),
    //     text: this.translate.instant('global.tutorialNewMap.prohibitions.text1')
    //   },
    //   {
    //     attachTo: {
    //       element: '.pdfPrint',
    //       on: 'bottom'
    //     },
    //     cancelIcon: {
    //       enabled: false
    //     },
    //     buttons: [
    //       builtInButtons.cancel,
    //       builtInButtons.next
    //     ],
    //     classes: 'shepherd-success',
    //     id: '.pdfPrint',
    //     title: this.translate.instant('global.tutorialNewMap.pdfPrint.title1'),
    //     text: this.translate.instant('global.tutorialNewMap.pdfPrint.text1')
    //   },
    //   {
    //     attachTo: {
    //       element: '.detailCard',
    //       on: 'bottom'
    //     },
    //     cancelIcon: {
    //       enabled: false
    //     },
    //     buttons: [
    //       builtInButtons.cancel,
    //       builtInButtons.next
    //     ],
    //     classes: 'shepherd-success',
    //     id: '.detailCard',
    //     title: this.translate.instant('global.tutorialNewMap.detailCard.title1'),
    //     text: this.translate.instant('global.tutorialNewMap.detailCard.text1')
    //   },
    //   {
    //     attachTo: {
    //       element: '.feedback',
    //       on: 'bottom'
    //     },
    //     cancelIcon: {
    //       enabled: false
    //     },
    //     buttons: [
    //       builtInButtons.cancel,
    //       builtInButtons.next
    //     ],
    //     classes: 'shepherd-success',
    //     id: '.feedback',
    //     title: this.translate.instant('global.tutorialNewMap.feedback.title1'),
    //     text: this.translate.instant('global.tutorialNewMap.feedback.text1')
    //   },
    //   {
    //     attachTo: {
    //       element: '.question',
    //       on: 'bottom'
    //     },
    //     cancelIcon: {
    //       enabled: false
    //     },
    //     buttons: [
    //       builtInButtons.cancel,
    //       {
    //         classes: 'restart-button',
    //         text: this.translate.instant('global.restartTutorial') || 'Ricomincia',
    //         action: function () {
    //           that.resetTutorialState(true);
    //           that.shepherdService.cancel();
    //           setTimeout(() => {
    //             that.tutorialMap();
    //           }, 100);
    //         },
    //       }
    //     ],
    //     classes: 'shepherd-success',
    //     id: '.question',
    //     title: this.translate.instant('global.tutorialNewMap.question.title1'),
    //     text: this.translate.instant('global.tutorialNewMap.question.text1')
    //   }
    // ]
    // );
   // this.shepherdService.start();
  }

  /**
   * Carica e visualizza i campi agricoli sulla mappa usando il sistema persistente
   * Funzionalità portata da tracking-map.component.ts
   * AGGIUNTO: Debounce per evitare chiamate multiple
   */
  setFields(): void {
    // Verifica se i campi devono essere nascosti
    if (this.hideFields) {
      this.mapManager.updateFields([], false); // Svuota i campi usando il sistema persistente
      this.fieldsLoaded = true; // I campi sono "caricati" (nascosti)
      console.log('✅ Campi nascosti, controllo centramento...');
      this.checkAndCenterMap();
      return;
    }

    // Verifica che abbiamo le informazioni del cliente
    if (!this.selectedCustomerUidSelector$ || !this.selectedCustomerUidSelector$.uid) {
      console.warn('❌ Impossibile caricare i fields: cliente non selezionato');
      return;
    }

    const currentCustomerUid = this.selectedCustomerUidSelector$.uid;

    // 🛡️ GUARD: Evita chiamate multiple per lo stesso customer
    if (this.fieldsLoadingInProgress && this.lastFieldsCustomerUid === currentCustomerUid) {
      console.log('⏭️ setFields() già in progress per customer:', currentCustomerUid, '- SKIP');
      return;
    }

    // 🛡️ DEBOUNCE: Cancella timeout precedente se presente
    if (this.fieldsLoadTimeout) {
      clearTimeout(this.fieldsLoadTimeout);
      this.fieldsLoadTimeout = null;
      console.log('🚫 Timeout precedente cancellato');
    }

    // Imposta il timeout per evitare chiamate troppo frequenti
    this.fieldsLoadTimeout = setTimeout(() => {
      this.executeSetFields(currentCustomerUid);
    }, 200); // 200ms di debounce
  }

  /**
   * Esegue effettivamente il caricamento dei fields
   */
  private executeSetFields(customerUid: string): void {
    // Verifica che il customer sia ancora quello richiesto
    if (!this.selectedCustomerUidSelector$ || this.selectedCustomerUidSelector$.uid !== customerUid) {
      console.log('⚠️ Customer cambiato durante debounce, skip caricamento fields');
      return;
    }

    // Imposta flag di caricamento in corso
    this.fieldsLoadingInProgress = true;
    this.lastFieldsCustomerUid = customerUid;
    console.log('🌾 INIZIO caricamento fields per customer:', customerUid);

    // console.log('🌾 Caricamento campi per cliente:', this.selectedCustomerUidSelector$.uid);

    // Verifica se i campi sono già stati caricati per questo cliente
    const currentFieldsCount = this.mapManager.getFieldsPolygonsCount ? this.mapManager.getFieldsPolygonsCount() : 0;

    // Se abbiamo campi nel nostro array locale, proviamo a re-applicarli prima di fare una nuova chiamata API
    // MA solo se non stiamo forzando un ricaricamento completo
    if (currentFieldsCount > 0 && this.fields && this.fields.length > 0) {
      console.log('🔄 Re-applicazione campi esistenti (' + this.fields.length + ') per assicurare visibilità');
      this.mapManager.updateFields(this.fields, false);

      // Imposta subito i campi come caricati se stiamo riapplicando
      this.fieldsLoaded = true;
      console.log('✅ Campi ri-applicati, controllo centramento...');
      this.checkAndCenterMap();

      // RESET flag caricamento
      this.fieldsLoadingInProgress = false;
      this.fieldsLoadTimeout = null;

      // Verifica dopo un delay se i campi sono ora visibili
      setTimeout(() => {
        console.log('📍 Ricaricamento completo da API per assicurare visibilità');
        this.forceReloadFields();
      }, 300);

      return;
    }

    // Se il count indica campi presenti ma l'array locale è vuoto, procedi con la chiamata API
    if (currentFieldsCount > 0 && (!this.fields || this.fields.length === 0)) {
      console.log('🔄 Count indica campi presenti ma array locale vuoto, ricaricamento da API');
    }

    this.forceReloadFields();
  }

  /**
   * Reset completo dello stato dei fields per un nuovo customer
   */
  private resetFieldsStateForNewCustomer(): void {
    // Reset dei flag di caricamento per il nuovo cliente
    this.vehiclesLoaded = false;
    this.fieldsLoaded = false;
    this.mapCentered = true;

    // Reset dei flag specifici per i fields
    this.fieldsLoadingInProgress = false;
    this.lastFieldsCustomerUid = null;

    // Cancella timeout in corso se presente
    if (this.fieldsLoadTimeout) {
      clearTimeout(this.fieldsLoadTimeout);
      this.fieldsLoadTimeout = null;
    }

    console.log('🔄 Stato fields resettato per nuovo customer');
  }

  /**
   * Forza il ricaricamento completo dei campi da API
   */
  private forceReloadFields(): void {
    if (!this.selectedCustomerUidSelector$ || !this.selectedCustomerUidSelector$.uid) {
      console.warn('❌ forceReloadFields: Customer non disponibile');
      this.fieldsLoadingInProgress = false;
      this.fieldsLoadTimeout = null;
      return;
    }

    const customerUid = this.selectedCustomerUidSelector$.uid;
    console.log('📡 API CALL - forceReloadFields per customer:', customerUid);

    // Effettua la chiamata API per recuperare i fields
    this.apiService.get(
      TRACKING_FIELDS_ENDPOINT.replace(':uidCustomer', customerUid)
    ).pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (fields: any) => {
        // console.log('📍 Ricevuti', fields.length, 'campi dall\'API');

        // Elabora ogni field ricevuto
        const processedFields = fields.map((field: any) => {
          // Parsa la configurazione di disegno dal JSON se è una stringa
          if (typeof field.drawConf === 'string') {
            field.drawConf = JSON.parse(field.drawConf);
          }
          // Imposta il flag per il layer geometrico
          field.geometryLayer = true;
          return field;
        });

        // Aggiorna l'array locale per compatibilità
        this.fields = processedFields;

        // Prima svuota i campi esistenti per forzare un refresh completo
        this.mapManager.updateFields([], false);

        // Poi aggiungi i nuovi campi dopo un breve delay
        setTimeout(() => {
          this.mapManager.updateFields(processedFields, false);
          console.log('✅ Campi ricaricati completamente sulla mappa');

          // Imposta flag campi caricati
          this.fieldsLoaded = true;
          console.log('✅ Campi caricati, controllo centramento...');
          this.checkAndCenterMap();

          // RESET flag caricamento completato
          this.fieldsLoadingInProgress = false;
          this.fieldsLoadTimeout = null;
        }, 100);
      },
      error: (error) => {
        console.error('❌ Errore nel caricamento dei fields:', error);
        console.warn('Mantengo i campi esistenti in caso di errore di rete');

        // RESET flag caricamento anche in caso di errore
        this.fieldsLoadingInProgress = false;
        this.fieldsLoadTimeout = null;
      }
    });
  }

  /**
   * Carica la lista dei fields senza disegnarli sulla mappa
   * Funzionalità aggiuntiva per compatibilità
   */
  setFieldsList(): void {
    this.fieldsList = [];

    if (!this.selectedCustomerUidSelector$ || !this.selectedCustomerUidSelector$.uid) {
      console.warn('Impossibile caricare la lista dei fields: cliente non selezionato');
      return;
    }

    this.apiService.get(
      TRACKING_FIELDS_ENDPOINT.replace(':uidCustomer', this.selectedCustomerUidSelector$.uid)
    ).pipe(
      takeUntil(this.destroy$)
    ).subscribe({
      next: (fields: any) => {
        for (let field of fields) {
          this.fieldsList.push(field);
        }
      },
      error: (error) => {
        console.error('❌ Errore nel caricamento della lista fields:', error);
      }
    });
  }

  /**
   * Metodi pubblici per gestire i campi agricoli
   */

  // Toggle della visibilità delle etichette dei campi (i campi rimangono sempre sulla mappa)
  toggleFieldLabels(): boolean {
    return this.mapManager.toggleFieldLabels();
  }

  // Mostra/nasconde completamente i campi agricoli dalla mappa
  toggleFields(): void {
    this.hideFields = !this.hideFields;
    if (!this.hideFields) {
      // ✅ RIATTIVATO
      this.setFields(); // Carica i campi con il nuovo sistema persistente
    } else {
      // Nasconde i poligoni dei fields usando il nuovo sistema
      this.mapManager.updateFields([], false);
    }
  }

  // Forza il ricaricamento dei campi
  refreshFields(): void {
    if (!this.hideFields) {
      // ✅ RIATTIVATO
      this.setFields();
    }
  }

  // Ottieni il numero di campi caricati
  getFieldsCount(): number {
    return this.mapManager.getFieldsPolygonsCount();
  }

  // Mostra le etichette dei campi
  showFieldLabels(): void {
    this.mapManager.showFieldLabels();
  }

  // Nasconde le etichette dei campi
  hideFieldLabels(): void {
    this.mapManager.hideFieldLabels();
  }

  // Verifica se le etichette dei campi sono visibili
  areFieldLabelsVisible(): boolean {
    return this.mapManager.fieldLabelsVisible;
  }

  // Metodo di debug per verificare lo stato dei campi
  debugFieldsState(): void {
    const fieldsCount = this.mapManager.getFieldsPolygonsCount ? this.mapManager.getFieldsPolygonsCount() : 0;
    // console.log('🔍 DEBUG Campi:');
    // console.log('  - Campi sulla mappa:', fieldsCount);
    // console.log('  - Campi array locale:', this.fields?.length || 0);
    // console.log('  - hideFields:', this.hideFields);
    // console.log('  - Cliente UID:', this.selectedCustomerUidSelector$?.uid);
    // console.log('  - Mappa inizializzata:', !!this.map);

    // if (this.fields && this.fields.length > 0) {
    //   console.log('  - Primo campo esempio:', this.fields[0]);
    // }
  }

  // Metodo per gestire il centramento finale quando tutto è caricato
  private checkAndCenterMap(): void {
    // Verifica se entrambi i caricamenti sono completi e la mappa deve essere centrata
    if (this.mapCentered && this.vehiclesLoaded && (this.fieldsLoaded || this.hideFields)) {
      // console.log('🎯 Centrando mappa: veicoli e campi caricati');

      // Usa il metodo del mapManager per centrare su tutti gli elementi
      setTimeout(() => {
        this.mapManager.centerMapOnAllElements();
        this.mapCentered = false; // Impedisce ulteriori centramenti automatici
        // console.log('✅ Mappa centrata su tutti gli elementi');
      }, 500); // Piccolo delay per assicurarsi che tutto sia renderizzato
    } else {
      // console.log('⏳ In attesa del caricamento completo:', {
      //   mapCentered: this.mapCentered,
      //   vehiclesLoaded: this.vehiclesLoaded,
      //   fieldsLoaded: this.fieldsLoaded,
      //   hideFields: this.hideFields
      // });
    }
  }

  /**
   * Forza la visibilità del layer dei campi agricoli
   * Questo metodo assicura che i campi siano visibili ricaricandoli completamente
   */
  forceFieldsLayerVisibility(): void {
    if (!this.map || !this.mapManager) {
      console.warn('⚠️ Mappa o mapManager non disponibili per forzare visibilità campi');
      return;
    }

    try {
      // console.log('🔧 Forzando visibilità layer campi...');

      // Metodo 1: Forza un refresh della mappa
      if (this.map) {
        // console.log('📍 Invalidando size della mappa per refresh campi');
        this.map.invalidateSize();
      }

      // Metodo 2: Se i campi sono presenti ma non visibili, proviamo a ricaricarli
      const fieldsCount = this.mapManager.getFieldsPolygonsCount ? this.mapManager.getFieldsPolygonsCount() : 0;
      if (fieldsCount > 0 && this.fields && this.fields.length > 0) {
        // console.log('📍 Campi presenti ma non visibili, ricaricamento forzato da API');
        // Svuota temporaneamente i campi
        this.mapManager.updateFields([], false);

        // ✅ RIATTIVATO - Ricarica dopo un breve delay
        setTimeout(() => {
          this.setFields();
        }, 200);
      }

      // console.log('✅ Tentativo di forzare visibilità campi completato');
    } catch (error) {
      console.error('❌ Errore nel forzare visibilità campi:', error);
    }
  }

  // // Metodi per gestire gli eventi del pannello geofence
  // onGeofencePolygonAdded(): void {
  //   console.log('🔺 Polygon geofence added');
  //   this.drawPolygon();
  // }

  // onGeofenceRectangleAdded(): void {
  //   console.log('⬜ Rectangle geofence added');
  //   this.drawSquare();
  // }

  // onGeofenceLaneAdded(): void {
  //   console.log('🛣️ Lane geofence added');
  //   this.drawPolyline();
  // }

  // // Metodi di disegno geofence
  // drawPolygon(): void {
  //   this.isField = false;
  //   this.editMode = false;
  //   let color = this.utilsService.getRandomColor();

  //   // TODO: Implementare metodi nel ActiaMapService
  //   // this.mapManager.removeAllShapes();
  //   // if (!this.isField) {
  //   //   this.mapManager.createPolygon(color);
  //   // }

  //   console.log('🔺 Iniziando disegno poligono con colore:', color);
  //   this.addGeofence('Polygon', 'Poly', color);
  // }

  // drawSquare(): void {
  //   this.isField = false;
  //   this.editMode = false;
  //   let color = this.utilsService.getRandomColor();

  //   // TODO: Implementare metodi nel ActiaMapService
  //   // this.mapManager.removeAllShapes();
  //   // this.mapManager.createRectangle(color);

  //   console.log('⬜ Iniziando disegno rettangolo con colore:', color);
  //   this.addGeofence('Polygon', 'Rectangle', color);
  // }

  // drawPolyline(): void {
  //   this.isField = false;
  //   this.editMode = false;
  //   let color = this.utilsService.getRandomColor();

  //   // TODO: Implementare metodi nel ActiaMapService
  //   // this.mapManager.removeAllShapes();
  //   // this.mapManager.createPolyline(color);

  //   console.log('🛣️ Iniziando disegno polyline con colore:', color);
  //   this.addGeofence('Polygon', 'Line', color);
  // }

  // addGeofence(geometryType: string, mode: string, color: string): void {
  //   this.geofenceDraw = {
  //     uid: `geofence_${Date.now()}`, // Aggiungiamo un UID unico
  //     name: '',
  //     description: '',
  //     inside: true,
  //     geometry: { type: geometryType, coordinates: [] },
  //     drawConf: { color: color, mode: mode },
  //     isNew: true,
  //     hasCurfew: false,
  //     schedule: [],
  //     vehicles: []
  //   };

  //   if (this.isField) {
  //     this.geofenceDraw.isNew = false;
  //   }

  //   // Rimuovi l'ultimo geofence se era nuovo e non salvato
  //   if (this.visibleGeofences.length > 0) {
  //     const lastGeofence = this.visibleGeofences[this.visibleGeofences.length - 1];
  //     if (lastGeofence.isNew === true || lastGeofence.isNew === false) {
  //       this.visibleGeofences.pop();
  //       // TODO: Implementare removeAllPolygonsFields nel servizio
  //       // this.mapManager.removeAllPolygonsFields();
  //     }
  //   }

  //   this.visibleGeofences.push(this.geofenceDraw);
  //   this.selectedItems = [this.geofenceDraw];

  //   console.log('✅ Geofence aggiunto:', this.geofenceDraw);
  // }

  // // Metodo per inizializzare geofence di test
  // private initializeTestGeofences(): void {
  //   this.visibleGeofences = [
  //     {
  //       uid: 'test_geofence_1',
  //       name: 'Zona Centro',
  //       description: 'Area del centro città',
  //       inside: true,
  //       geometry: { type: 'Polygon', coordinates: [] },
  //       drawConf: { color: '#FF5722', mode: 'Poly' },
  //       isNew: false,
  //       hasCurfew: false,
  //       schedule: [],
  //       vehicles: []
  //     },
  //     {
  //       uid: 'test_geofence_2',
  //       name: 'Parcheggio Nord',
  //       description: 'Area parcheggio settore nord',
  //       inside: true,
  //       geometry: { type: 'Polygon', coordinates: [] },
  //       drawConf: { color: '#4CAF50', mode: 'Rectangle' },
  //       isNew: false,
  //       hasCurfew: true,
  //       schedule: ['Lun-Ven 08:00-18:00'],
  //       vehicles: ['VH001', 'VH002']
  //     },
  //     {
  //       uid: 'test_geofence_3',
  //       name: 'Strada Principale',
  //       description: 'Arteria di collegamento principale',
  //       inside: false,
  //       geometry: { type: 'Polygon', coordinates: [] },
  //       drawConf: { color: '#2196F3', mode: 'Line' },
  //       isNew: false,
  //       hasCurfew: false,
  //       schedule: [],
  //       vehicles: ['VH003']
  //     }
  //   ];

  //   console.log('🧪 Geofence di test inizializzati:', this.visibleGeofences.length);
  // }

  // onGeofenceFieldsImported(): void {
  //   console.log('🌾 Fields imported as geofence');
  //   this.isField = true;
  //   this.editMode = true;
  //   this.setFieldsList();
  // }

  // onGeofenceSelectionChanged(event: any): void {
  //   console.log('🎯 Geofence selection changed:', event);
  //   if (event && event.selectedItems && event.selectedItems.length > 0) {
  //     this.geofenceDraw = event.selectedItems[0];
  //     this.selectedItems = event.selectedItems;

  //     // Visualizza il geofence selezionato sulla mappa
  //     // TODO: Implementare la visualizzazione del geofence sulla mappa
  //     console.log('📍 Geofence selezionato:', this.geofenceDraw);
  //   }
  // }

  // onGeofenceSave(event: any): void {
  //   console.log('💾 Save geofence:', event);
  //   if (event && event.uid) {
  //     // Implementa la logica per salvare geofence nel backend
  //     // this.apiService.saveGeofence(event).subscribe(...);

  //     // Per ora, aggiorna lo stato locale
  //     event.isNew = false;
  //     console.log('✅ Geofence salvato:', event);
  //   }
  // }

  // onGeofenceDelete(event: any): void {
  //   console.log('🗑️ Delete geofence:', event);
  //   if (event && event.uid) {
  //     // Rimuovi dalla lista
  //     const index = this.visibleGeofences.findIndex(g => g.uid === event.uid);
  //     if (index > -1) {
  //       this.visibleGeofences.splice(index, 1);

  //       // Rimuovi dalla mappa
  //       // TODO: Implementare rimozione dalla mappa
  //       console.log('✅ Geofence eliminato:', event);
  //     }
  //   }
  // }

  // onGeofenceColorChanged(event: any): void {
  //   console.log('🎨 Geofence color changed:', event);
  //   if (event && event.value && this.geofenceDraw) {
  //     this.geofenceDraw.drawConf.color = event.value;

  //     // Aggiorna il colore sulla mappa
  //     // TODO: Implementare aggiornamento colore sulla mappa
  //     console.log('🎨 Colore geofence aggiornato:', event.value);
  //   }
  // }



  closeGeofencePanel(): void {
    console.log('❌ Closing geofence panel');
    // Usa il metodo del service per chiudere il pannello e nascondere i geofence
    this.mapManager.closeGeofencePanel();
    // Aggiorna gli stati locali
    this.geofenceNavOpened = false;
    this.geofenceActive = false;

    // Ridimensiona la mappa dopo la chiusura
    setTimeout(() => {
      this.resizeMap();
      console.log('🔄 Mappa ridimensionata dopo chiusura pannello geofence');
    }, 350);
  }
}
